{
  "approvals": {
    "byDelegation": "By delegation from {{name}} until {{until}}"
  }
}
